export default __webpack_public_path__ + "static/media/Pross03.dd9484bc.jpg";